import { computed } from 'vue';
import { careers } from '@/utils/careers';
import { usePermissions } from './usePermissions';

// Careers the current user may read are gated by the `careers` / `read_{career}`
// permission (enforced server-side by CaregiverPolicy::Scope). This exposes the
// same gate to career option lists so users only pick careers they can access.
export function useAccessibleCareers() {
  const { hasPermission } = usePermissions();

  function canAccessCareer(value: string) {
    return hasPermission.value('careers', `read_${value}`);
  }

  const accessibleCareers = computed(() => careers.filter((career) => canAccessCareer(career.value)));

  return { accessibleCareers, canAccessCareer };
}
